import { matchRoutePath } from '../../../../../shared/frontend/libs/router/router-helpers';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_CHARACTER_MYTHIC_PLUS_SEASON,
  SET_CHARACTER_MYTHIC_PLUS_PROGRESS_LOADING,
  SET_CHARACTER_MYTHIC_PLUS_PROGRESS
} from '../actions/characterActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { namedRoutes } from '../bundles/routes';
import { decodeSearchParams } from '../../../../../shared/frontend/libs/utils';

const initialState = {
  season: null,
  loadingMythicPlusProgress: {},
  mythicPlusProgress: {},
  loadedMythicPlusProgress: {}
};

export default function characterMythicPlusProgressReducer(
  state: any = initialState,
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case SET_CHARACTER_MYTHIC_PLUS_SEASON: {
      return {
        ...state,
        season: action.payload
      };
    }
    case SET_CHARACTER_MYTHIC_PLUS_PROGRESS_LOADING: {
      return {
        ...state,
        loadingMythicPlusProgress: {
          ...state.loadingMythicPlusProgress,
          [action.payload.season]: action.payload.loading
        },
        loadedMythicPlusProgress: {
          ...state.loadedMythicPlusProgress,
          [action.payload.season]: !action.payload.loading
        }
      };
    }
    case SET_CHARACTER_MYTHIC_PLUS_PROGRESS: {
      return {
        ...state,
        mythicPlusProgress: {
          ...state.mythicPlusProgress,
          [action.payload.season]: action.payload
        },
        loadedMythicPlusProgress: {
          ...state.loadedMythicPlusProgress,
          [action.payload.season]: true
        }
      };
    }
    case LOCATION_CHANGE: {
      // server render may have pre-populated state, so we don't want to nuke it
      if (action.payload.isFirstRendering) {
        const params = decodeSearchParams(action.payload.location.search, { ignoreQueryPrefix: true });
        return state.season !== params.season ? { ...state, season: params.season } : state;
      }

      const match = matchRoutePath(
        {
          path: namedRoutes.CharacterDetails,
          end: false
        },
        action.payload.location.pathname
      );

      if (match) {
        const params = decodeSearchParams(action.payload.location.search, { ignoreQueryPrefix: true });
        return state.season !== params.season ? { ...state, season: params.season } : state;
      }

      return initialState;
    }
    default: {
      return state;
    }
  }
}
